import styles from './ScoreDetail.module.css'
import React from 'react';

function ScoreDetail({
    state,
    scores,
    puzzles
}){
    return (
        state === 'open' &&
        <div className={styles.container + ' ' + state}>
            <div className={styles.heading}>Puzzle</div>
            <div className={styles.heading}>Score</div>
            <div className={styles.heading}>Time</div>
            <div className={styles.heading}>Words</div>
            {
                
                puzzles.map((v, i) => {
                    return (
                    <React.Fragment key={i}>
                        <div>{v.Sequence}</div>
                        <div>{scores[v.id]?.score}</div>
                        <div>{scores[v.id]?.time}</div>
                        <div>{scores[v.id]?.correct}</div>
                    </React.Fragment>
                    )
                })
                    
            }
        </div>

    );
}

export default ScoreDetail;